import AxiosRequestBuilder from '@/utils/axios-request-builder'
import { IAccounts } from '@/types/personal-accounts'
import { Endpoints, urlBuilder } from '@/connectors/endpoints'
import { mapper } from '@/mappers'
import { accountsMap } from '@/mappers/personal-account'

const showPersonalAccount = (personalAccountId: number, moid: number) => {
  return new AxiosRequestBuilder<IAccounts>({
    url: urlBuilder(Endpoints.SHOW_PERSONAL_ACCOUNT, String(personalAccountId), String(moid)),
    method: 'get',
    responseMapperFunction: mapper,
    responseMapper: accountsMap
  }).exec().then((response) => response.data)
}

export default showPersonalAccount
